import React from 'react';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import AuthContext from 'helpers/authContext';
import { useQueryString } from 'helpers/effects';
import CreditBundleList from 'components/CreditBundle/List';

const ScreenCreditBundleList = () => {
  const initialFilters = useQueryString();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <AuthContext.Consumer>
          {value => (
            <CreditBundleList me={value} initialFilters={initialFilters} />
          )}
        </AuthContext.Consumer>
      </GridItem>
    </GridContainer>
  );
};

export default ScreenCreditBundleList;
